module.exports = __webpack_public_path__ + "img/Qpostchange.1e8fce3f.png";